module.exports = __webpack_public_path__ + "static/media/follow.28decbb9.svg";